export default __webpack_public_path__ + "static/media/schedule_chats.62f16229.png";